import { IConfig } from '@cian/config/shared';

import {
  INewbuildingBrokerSchema,
  TSource,
} from '../../../../repositories/newbuilding-flat-view-order/entities/consulting_request/NewbuildingBrokerSchema';
import { getCianSource, isNewbuildingBrokerCianSource } from '../../../../utils/cianSource';
import { toCamelCase } from '../../../../utils/formatters';

export const prepareNewbuildingBroker = (config: IConfig): INewbuildingBrokerSchema | undefined => {
  const cianSource = getCianSource();

  if (cianSource && isNewbuildingBrokerCianSource(cianSource, config)) {
    return {
      source: toCamelCase(cianSource) as TSource,
    };
  }

  return undefined;
};
